
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(188|496|910)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
